<template>
  <section class="w-100 contracts-menu">
    <div v-if="isLoading" class="contracts-message">
      {{ t("LOADING_MESSAGE") }}
    </div>
    <div v-else-if="documents.length === 0" class="contracts-message">
      {{ t("CL_NO_CONTRACTS_AVAILABLE") }}
    </div>
    <div v-else class="contracts-list">
      <button
        v-for="document in documents"
        :key="document.key"
        class="contracts-item"
        type="button"
        @click="$emit('open-document', document)"
      >
        <span class="contracts-item-text">
          {{ getDocumentLabel(document.key) }}
        </span>
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { useI18n as useGlobalI18n } from "vue-i18n";
import type { HelpContractDocument } from "@/apps/credit-line/helpers/helpContracts.helper";

defineProps<{
  documents: HelpContractDocument[];
  isLoading: boolean;
}>();

defineEmits<{
  (event: "open-document", document: HelpContractDocument): void;
}>();

const { t } = useI18n();
const { t: globalT } = useGlobalI18n();

const getDocumentLabel = (documentKey: string): string => {
  const appTranslationKey = `CREDIT_LINE.${documentKey}`;
  const appTranslationValue = globalT(appTranslationKey);

  if (appTranslationValue !== appTranslationKey) {
    return appTranslationValue;
  }

  const sharedTranslationKey = `SHARED.${documentKey}`;
  const sharedTranslationValue = globalT(sharedTranslationKey);

  if (sharedTranslationValue !== sharedTranslationKey) {
    return sharedTranslationValue;
  }

  return documentKey;
};
</script>

<style lang="scss" scoped>
.contracts-menu {
  margin-top: 0.5rem;
}

.contracts-message {
  color: #595a5a;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  padding: 1rem 1.5rem;
}

.contracts-list {
  border-top: 1px solid #ddd;
}

.contracts-item {
  align-items: center;
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #ddd;
  color: #595a5a;
  display: flex;
  font-size: 1rem;
  font-weight: 600;
  justify-content: space-between;
  line-height: 1.75rem;
  min-height: 5rem;
  padding: 1rem 1.5rem;
  text-align: left;
  width: 100%;
}

.contracts-item-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
